import { render, staticRenderFns } from "./comment-message.vue?vue&type=template&id=b222ed16&"
import script from "./comment-message.vue?vue&type=script&lang=js&"
export * from "./comment-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports